import axios from 'axios'
import store from '@/store'
import { requestConsolelog } from '@/utils/tracelog'

const apiBaseURL = (typeof config === "undefined" ? process.env.VUE_APP_BACKEND_URL : config.VUE_CONFIG_APP_API || process.env.VUE_APP_BACKEND_URL)

// create an axios instance
const service = axios.create({
  baseURL: apiBaseURL, // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.state.user.token) {
      // get token from persisted store
      config.headers.Authorization = store.state.user.token

      requestConsolelog('request: config.headers.Authorization = %s', config.headers.Authorization)
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // refresh token
    if (response.headers.authorization) {
      const refresh = response.headers.authorization

      store.commit('user/SET_TOKEN', refresh)
      response.data.token = refresh

      requestConsolelog('response: refresh token = %s', refresh)
    }

    return response.data
  },
  error => {
    console.log('err ' + error) // for debug

    if (error.response.status === 401 && error.response.data.message === 'Token has expired') {
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    }

    if (error.response.status === 401 && error.response.data.message === 'Token has expired and can no longer be refreshed') {
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    }

    return Promise.reject(error)
  }
)

export default service
